import React, { useState } from 'react'
import { ToastContext } from '@pdrj/pmi-iqos-ds-react'
import {
  CommonTranslations,
  PublishedComponent,
  parseTranslations,
  cookie,
  constants
} from '@pdrj/pmi-iqos-shared-react'
import { AvatarFormPopup } from '@iqosphere-common/components'
import { getInitialPropsMock } from '@iqosphere-common/utils'
import AvatarUpdateFormTranslations from './avatar-update-form.json'

const AvatarUpdateFormComponent = ({ translations, line, avatarList }) => {
  const [openModal, setOpenModal] = useState(true)

  const defaultAvatar = avatarList.find(avatar => avatar.default) || []
  const userInfo = {
    avt: {
      code: defaultAvatar.avatar_code,
      accessory: ''
    }
  }

  const onCloseHandler = () => {
    const spiceId = cookie.getSpiceId()
    cookie.set(`${constants.COOKIE_SKIPPED_AVATAR}_${spiceId}`, true)
    setOpenModal(false)
  }

  return (
    <AvatarFormPopup
      isOpen={openModal}
      setOpenModal={setOpenModal}
      avatarList={avatarList}
      onClose={onCloseHandler}
      userInfo={userInfo}
      line={line}
      translations={translations}
    />
  )
}

const AvatarUpdateForm = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={AvatarUpdateFormComponent}
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...AvatarUpdateFormTranslations,
  ...CommonTranslations
}

const defaultTranslations = {
  ...parseTranslations(ComponentTranslations, true)
}

const ComponentDefaultProps = {
  componentName: 'AvatarUpdateForm',
  translations: defaultTranslations,
  defaultTranslations: defaultTranslations,
  translationsConfig: ComponentTranslations
}

AvatarUpdateForm.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    line: !!req?.query?.line,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: () => {
      const avatarList =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('avatarList')
          : (req.body.extra && req.body.extra.avatars) || []
      return { avatarList }
    }
  })
}

export default AvatarUpdateForm
